import { Helmet } from "react-helmet-async";

const SITE_NAME = "Invest Hospitality";
const DEFAULT_DESC =
  "Invest Hospitality — holding italiana per lo sviluppo e la gestione di hotel a Milano. 15 strutture operative, 5 in pipeline. Dal 2014.";
const DEFAULT_IMAGE =
  "";

/**
 * SEO component: titolo, description, Open Graph, Twitter Card, canonical.
 * Usage: <SEO title="..." description="..." image="..." path="/chi-siamo" />
 */
export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  path = "",
  type = "website",
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://investhospitality.it";
  const url = `${origin}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="it" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="it_IT" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
